export default "__VITE_ASSET__C9lDLHH8__"